export const CALENDLY_URL = "https://calendly.com/savacplus/new-meeting";

declare global {
  interface Window {
    Calendly?: {
      initPopupWidget: (opts: { url: string }) => void;
      preloadPopupWidget: (opts: { url: string }) => void;
    };
  }
}

export function openCalendly() {
  if (window.Calendly) {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
  } else {
    window.open(CALENDLY_URL, "_blank");
  }
}
